export const NCEER = 'NCEER2001'
export const BOULANGER_IDRISS_DET = 'BoulangerIdriss2014Deterministic'
export const BOULANGER_IDRISS_PROB = 'BoulangerIdriss2014Probabilistic'
export const MOSS_PROB = 'MossEtAl2006Probabilistic'

export type LiquefactionMethodType =
  | typeof NCEER
  | typeof BOULANGER_IDRISS_DET
  | typeof BOULANGER_IDRISS_PROB
  | typeof MOSS_PROB

export type CalculationCPTDataPointType = {
  id: number
  level: number
  fos_liq: number
  CRR: number
  CSR: number
  LPI: number
  rud_s: number
  rud_ps: number
  s: number
  qc_s: number
  qc_ps: number
  LDI: number
  LSN: number
  PL: number
}
